import { Box, Typography } from '@mui/material';
import { colors } from '@src/styles';
import { monoFontFamily, monoLabelSX } from '../../scriptsStyles';

interface InfoFieldProps {
  label: string;
  value: string;
}

export const InfoField = ({ label, value }: InfoFieldProps) => {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ ...monoLabelSX, display: 'block', mb: 0.5 }}>{label}</Typography>
      <Typography
        sx={{
          fontFamily: monoFontFamily,
          fontSize: '12.5px',
          color: value === '—' ? colors.brand.textMuted : colors.brand.textStrong,
          whiteSpace: 'nowrap',
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};
